module.exports = __webpack_public_path__ + "public/img/昨日能耗报警统计.29a51fb9.png";